const { useEffect, useState } = require('react')
const { default: restrictedDatesApi } = require('services/api/restrictedtextingdate')

const useRestrictedDates = (startDate, endDate) => {
  const [restrictedDates, setRestrictedDates] = useState([])

  useEffect(() => {
    if (startDate && endDate) {
      restrictedDatesApi
        .getBetweenDates({ startDate, endDate })
        .then(res => {
          setRestrictedDates(res)
        })
        .catch(err => {
          console.warn(err)
        })
    }
  }, [startDate, endDate])

  return restrictedDates
}

export default useRestrictedDates
